import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import { baseUrl } from "../../../../services/config";
import EditAppointedStaff from "./EditAppointedStaff/EditAppointedStaff";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import Pagination from "@material-ui/lab/Pagination";

import SVG from "react-inlinesvg";
import DefineSallary from "./DefineSallary/DefineSallary";
import { Link, useHistory } from "react-router-dom";
import GenerateSallary from "./GenerateSallary/GenerateSallary";
import ViewStaffDetails from "./ViewStaffDetails/ViewStaffDetails";
import ViewStafStudents from "./ViewStafStudents/ViewStafStudents.js";
import { Paper } from "@material-ui/core";
import usePagination from "../../../../components/usePagination/usePagination";
import { PremissionChecker } from "../../../../services/PremissionChecker.js";
import { useAlert } from "react-alert";
import MySelect from "./../../CustomChallan/MySelect";
import makeAnimated from "react-select/animated";
import { components } from "react-select";
import { set } from "lodash";

const AppointedStaff = () => {
  const authToken = localStorage.getItem("userToken");
  const user = useSelector((state) => state.user.user);
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setpostPerPage] = useState(10);
  // console.log(user.user.campus.id)
  const [searchtext, setsearchtext] = useState("");
  const [generateModal, setgenerateModal] = useState(false);
  const [editModal, seteditModal] = useState(false);
  const [loading, setloading] = useState(false);
  const [currentObject, setcurrentObject] = useState({});
  const [studentDetails, setStudentDetails] = useState([]);
  const [AllStaff, setAllStaff] = useState([]);
  const [viewModal, setviewModal] = useState(false);
  const [studentView, setStudentView] = useState(false);
  const [defineSalaryModal, setdefineSalaryModal] = useState(false);
  const [viewLoading, setviewLoading] = useState(false);
  const [allcampuses, setallcampuses] = useState(user.campuses || []);
  const [campusID, setCampusID] = useState("");
  const [searchtext2, setsearchtext2] = useState("");
  const alert = useAlert();
  const dispatch = useDispatch();
  let campusidget = useSelector((state) => state.campuses.setselectedcampusid);
  const [previousselectedcampus, setpreviousselectedcampus] = useState(
    campusidget
  );

  //? Login Model Variable
  let [errorCreate, setErrorCreate] = useState("Please fill all fields");
  const [loginModal, setLoginModal] = useState(false);
  const [loginPassword, setLoginPassword] = useState("");
  const [loginEmail, setLoginEmail] = useState("");
  const [isAllFields, setIsAllFields] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState([]);

  const [classSectionArray, setClassSectionArray] = useState([]);
  const [campusesList, setCampusesList] = useState([]);
  const [classesList, setClassesList] = useState([]);
  const [sectionsList, setSectionsList] = useState([]);
  const [campusId, setCampusId] = useState([]);
  const [classIds, setClassIds] = useState([]);
  const [sectionIds, setSectionIds] = useState([]);
  const [selectedCampuses, setSelectedCampuses] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedSections, setSelectedSections] = useState([]);
  //? Login Model Variable

  useEffect(() => {
    if (campusidget != "") {
      setpreviousselectedcampus(campusidget);
      getAllStaff(campusidget);
    }
  }, []);

  const getAllCampus = async () => {
    await fetch(`${baseUrl}/campus`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) =>
        res.json().then((data) => {
          setallcampuses(data.payload);
        })
      )

      .catch((err) => {
        console.log("campus", err);
      });
  };
  const getAllStaff = (e) => {
    let id = "";
    if (e == undefined) {
      id = campusID;
    } else {
      id = e;
    }
    setCampusID(id);

    setpreviousselectedcampus(id);
    dispatch({
      type: "SELECTED_CAMPUS_ID",
      payload: {
        setselectedcampusid: id,
      },
    });
  };

  const openEditModal = (staff) => {
    setcurrentObject(staff);
    seteditModal(true);
  };

  const indexOfLastPost = currentPage * postPerPage;

  const indexOfFirstPost = indexOfLastPost - postPerPage;
  // const currentPosts = AllStaff.slice(indexOfFirstPost, indexOfLastPost);

  const dataSearch = AllStaff.filter((user) => {
    let text = searchtext.toLowerCase();
    return searchtext
      ? user?.full_name?.toLowerCase().includes(text) ||
          user?.emp_code
            ?.toString()
            .toLowerCase()
            .includes(text)
      : true;
  });

  // const dataSearch = currentPosts.filter((user) => {
  //   let text = searchtext.toLowerCase();
  //   return searchtext ? user?.full_name?.toLowerCase().includes(text)||user?.emp_code?.toLowerCase().includes(text) : true;
  // });
  const defineSalaryFunc = (staff) => {
    setcurrentObject(staff);
    setdefineSalaryModal(true);
  };

  const gotoDetails = (id, staff) => {
    setStudentDetails(staff.students);
    setviewLoading(true);
    fetchDetails(id);
  };

  const fetchDetails = async (id) => {
    // console.log('run ho rha h ',id)
    await fetch(`${baseUrl}/emp-salary-detail/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then(async (res) => {
        res.json().then((data) => {
          console.log(data.payload + "yyyyyyesdsdsdsdsdsd");
          setcurrentObject(data.payload);
          setviewModal(true);
          setviewLoading(false);
        });
      })
      .catch((err) => {
        console.log(err);
        setviewLoading(false);
      });
  };

  const opensalarygenerate = (staff) => {
    setcurrentObject(staff);
    setgenerateModal(true);
  };

  let [page, setPage] = useState(1);
  const PER_PAGE = 10;

  const count = Math.ceil(dataSearch.length / PER_PAGE);
  const _DATA = usePagination(dataSearch, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (!searchtext2) {
      alert.error("Please Enter Employee Code or Name");
      return;
    }
    searchByRegId(searchtext2);
  };
  const searchByRegId = (searchtext2) => {
    setloading(true);

    const data = {
      emp_code:
        typeof searchtext2 === "string" && !isNaN(searchtext2)
          ? searchtext2.toLocaleUpperCase()
          : "",
      emp_name:
        typeof searchtext2 === "string" && isNaN(searchtext2)
          ? searchtext2
          : "",
    };

    fetch(`${baseUrl}/appointed-employees/filter/name-code`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },

      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setAllStaff([]);
        setloading(false);
        if (data.metadata.success) {
          if (data.payload.length <= 0) {
            alert.error("Match not found");
          }
          setAllStaff(data.payload);
        } else if (!data.metadata.success) {
          Object.values(data.metadata.message).map((msg) => {
            alert.error(msg[0]);
          });
        }
      })
      .catch((err) => {
        console.log("err is re", err);
      });
  };
  const handleShowstaff = () => {
    setloading(true);

    fetch(`${baseUrl}/emp_appointed/${campusID}/1`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const arr = data.payload;
        arr.forEach((item, i) => {
          item["Sr"] = i + 1;
        });
        setAllStaff(arr);
        setloading(false);
      })
      .catch((err) => {
        setloading(false);
        console.log(err);
      });
  };

  const loginFunc = (staff) => {
    if (staff?.email == null) {
      return alert.error("Please Update Staff Email First");
    } else {
      setLoginPassword("");
      setSelectedStaff(staff);
      setLoginEmail(staff?.email);
      setCampusId([staff?.campus_id]);
      getUserCampusesClasses([staff?.campus_id]);
      setLoginModal(true);
    }
  };

  const getUserCampusesClasses = (id) => {
    if (!id || id.length === 0) {
      return alert.error("Please select at least one campus");
    }

    let data = {
      campus_ids: id,
    };

    fetch(`${baseUrl}/campuses-classes`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },

      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        let arr = [];

        data.payload.forEach((element) => {
          arr.push({
            label:
              element?.student_class?.name + " (" + element?.campus?.name + ")",
            student_class_id: element?.student_class_id,
            campus_id: element?.campus_id,
            value: element.id,
          });
        });
        setClassesList(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getClassSections = (id) => {
    if (campusId.length == 0 || id.length == 0) {
      return alert.error("Please select at least one campus or class");
    }

    let data = {
      campus_ids: campusId,
      student_class_ids: id,
    };

    fetch(`${baseUrl}/campuses-classes-sections`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },

      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        let arr = [];

        data.payload.forEach((element) => {
          arr.push({
            label:
              element?.section?.name +
              " (" +
              element?.class?.name +
              " - " +
              element?.campus?.name +
              " )",
            student_class_id: element?.student_class_id,
            global_section_id: element?.global_section_id,
            value: element.id,
          });
        });
        setSectionsList(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const animatedComponents = makeAnimated();
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const MultiValue = (props) => (
    <components.MultiValue {...props}>
      <span>{props.data.label}</span>
    </components.MultiValue>
  );

  const handleClassChange = (selected) => {
    setSelectedClasses([...selected]);
    let valuearray = [];

    selected.map((item, index) => {
      valuearray[index] = item.student_class_id;
    });

    // Use a Set to avoid duplicates
    const classSet = new Set();
    const classSectionMap = [];

    selected.forEach((cls) => {
      const classId = cls.student_class_id;
      if (!classSet.has(classId)) {
        classSet.add(classId);
        classSectionMap.push({
          class_id: classId,
          section_ids: [],
        });
      }
    });

    setClassSectionArray(classSectionMap);
    setClassIds([...valuearray]);
    getClassSections(valuearray);
  };

  const handleSectionChange = (selected) => {
    setSelectedSections([...selected]);
    let valuearray = [];

    selected.map((item, index) => {
      valuearray[index] = item.global_section_id;
    });

    const updatedClassSectionArray = classSectionArray.map((classItem) => {
      const matchingSections = selected
        .filter((sec) => sec.student_class_id == classItem.class_id)
        .map((sec) => sec.global_section_id);

      return {
        ...classItem,
        section_ids: matchingSections,
      };
    });

    console.log(updatedClassSectionArray);
    setClassSectionArray(updatedClassSectionArray);

    setSectionIds([...valuearray]);
  };

  const loginHandler = async () => {
    if (loginPassword == "" || loginPassword.length < 8) {
      setIsAllFields(true);
      return;
    }
    if (selectedStaff.user_id == null) {
      if (
        classSectionArray.length == 0 ||
        selectedClasses.length == 0 ||
        selectedSections.length == 0
      ) {
        setErrorCreate("Please select at least one class and section");
        setIsAllFields(true);
        return;
      }
    }
    setIsAllFields(false);
    let data = {
      employee_id: selectedStaff?.id,
      email: loginEmail,
      password: loginPassword,
      campus_id: selectedStaff?.campus_id,
      classes: classSectionArray,
    };
    console.log(data);
    setLoginLoading(true);

    await fetch(`${baseUrl}/teacher-sign-up`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(data),
    }).then((res) => {
      res
        .json()
        .then((data) => {
          console.log(data);
          setLoginLoading(false);

          if (data.metadata) {
            if (data.metadata.success) {
              if (selectedStaff.user_id == null) {
                alert.success("Staff Signup Successfully");
                if (searchtext2 != "") {
                  searchByRegId(searchtext2);
                } else {
                  handleShowstaff();
                }
              } else {
                alert.success("Staff Signup Updated Successfully");
                if (searchtext2 != "") {
                  searchByRegId(searchtext2);
                } else {
                  handleShowstaff();
                }
              }
            } else {
              alert.error("Error Occured");
            }
          } else {
            alert.error("Error Occured");
          }
          setIsAllFields(false);
          setLoginEmail("");
          setLoginPassword("");
          setSelectedClasses([]);
          setSelectedSections([]);
          setClassesList([]);
          setSectionsList([]);
          setClassSectionArray([]);
          setLoginModal(false);
        })
        .catch((err) => {
          setLoginLoading(false);

          console.log("err", err);
          alert.error("Error Occured");
          setIsAllFields(false);
          setLoginEmail("");
          setLoginPassword("");
          setSelectedClasses([]);
          setSelectedSections([]);
          setClassesList([]);
          setSectionsList([]);
          setClassSectionArray([]);
          setLoginModal(false);
        });
    });
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row mx-1 mt-5">
          <div className="col-md-4">
            <label className="form-control-label">
              <b>Select Campus</b>
              <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-control form-select h-40px"
              name="campus_id"
              value={allcampuses.length == 0 ? "" : previousselectedcampus}
              onChange={(e) => getAllStaff(e.target.value)}
              aria-label="Default select example"
            >
              <option value="">Select Campus</option>
              {allcampuses.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-5">
            <label className="form-control-label">
              <b>Search Employee</b>
            </label>
            <input
              className="form-control"
              onChange={(e) => setsearchtext(e.target.value)}
              id="searchInput"
              placeholder="Search ..."
            />
          </div>
          <div className="col-md-2 my-7">
            <button onClick={handleShowstaff} className="btn btn-primary">
              Show
            </button>
          </div>
        </div>
        <form onSubmit={handleSearchSubmit}>
          <div className="row mx-1">
            <div className="col-md-6">
              <input
                onChange={(e) => setsearchtext2(e.target.value)}
                className="form-control"
                placeholder="Enter Name or Employee ID"
              />
            </div>
            <div className="col-md-4">
              <button type="submit" className="btn btn-primary">
                Search
              </button>
            </div>
          </div>
        </form>
        {loading ? (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              marginTop: "20px",
            }}
          >
            <span className="spinner-border"></span>
          </div>
        ) : (
          <>
            <Table responsive className="mt-5">
              <thead>
                <tr className="text-center">
                  <th>Sr. no</th>
                  <th style={{ textAlign: "start" }}>Full Name</th>
                  <th style={{ textAlign: "start" }}>Email</th>
                  <th>Cnic No</th>
                  <th>Emp Code</th>
                  <th>Mobile No</th>
                  <th>Joining Date</th>
                  <th>SignUp/Reset</th>
                  <th>Define Salary</th>
                  <th>Edit</th>
                  <th>View</th>
                  <th>Generate Salary</th>
                </tr>
              </thead>
              <tbody>
                {_DATA.currentData().map((staf, index) => (
                  <tr key={staf.id}>
                    <td>{staf.Sr}</td>
                    <td
                      title={staf.full_name}
                      style={{ textAlign: "start", cursor: "pointer" }}
                    >
                      {staf.full_name}
                    </td>
                    {staf.email != null ? (
                      <td
                        title={staf.email}
                        style={{ textAlign: "start", cursor: "pointer" }}
                      >
                        {staf.email}
                      </td>
                    ) : (
                      <td></td>
                    )}
                    <td>{staf.cnic_no}</td>
                    <td style={{ textAlign: "center" }}>{staf.emp_code}</td>

                    <td>{"+92" + staf.mobile_no}</td>
                    <td style={{ textAlign: "center" }}>{staf.joining_date}</td>

                    <td className="text-center">
                      <a
                        className="btn btn-icon btn-light btn-hover-primary-custom btn-sm "
                        // disabled={student.user_id == null ? false : true}
                        onClick={() => loginFunc(staf)}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                          <SVG
                            style={{ margin: "10px" }}
                            className="logouticone"
                            src={
                              staf.user_id == null
                                ? toAbsoluteUrl(
                                    "/media/svg/icons/Navigation/Sign-in.svg"
                                  )
                                : toAbsoluteUrl(
                                    "/media/svg/icons/Navigation/Exchange.svg"
                                  )
                            }
                          />
                        </span>
                      </a>
                    </td>

                    <td style={{ textAlign: "center" }}>
                      {/* {staf.pay_scale_id == null ? ( */}
                      {PremissionChecker(
                        user,
                        "appointed_staff.define_salary"
                      ) ? (
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => defineSalaryFunc(staf)}
                          className={"svg-icon svg-icon-md svg-icon-success"}
                        >
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Money.svg"
                            )}
                          />
                        </span>
                      ) : null}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {PremissionChecker(
                        user,
                        "appointed_staff.edit_salary"
                      ) ? (
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => openEditModal(staf)}
                          className="svg-icon svg-icon-md svg-icon-primary-custom"
                        >
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Edit.svg"
                            )}
                          />
                        </span>
                      ) : null}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {PremissionChecker(
                        user,
                        "appointed_staff.view_details"
                      ) ? (
                        staf.pay_scale_id !== null ? (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => gotoDetails(staf.id, staf)}
                            className={
                              "svg-icon svg-icon-md svg-icon-primary-custom"
                            }
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Code/Info-circle.svg"
                              )}
                            />
                          </span>
                        ) : (
                          <span
                            title="You need to Define Salary First"
                            className="svg-icon svg-icon-md svg-icon-primary-custom"
                          >
                            Not
                          </span>
                        )
                      ) : null}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {PremissionChecker(
                        user,
                        "appointed_staff.generate_salary"
                      ) ? (
                        staf.pay_scale_id !== null ? (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => opensalarygenerate(staf)}
                            className={
                              "svg-icon svg-icon-md svg-icon-primary-custom"
                            }
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/General/Unlock.svg"
                              )}
                            />
                          </span>
                        ) : (
                          <span
                            title="You need to Define Salary First"
                            className="svg-icon svg-icon-md svg-icon-primary-custom"
                          >
                            No
                          </span>
                        )
                      ) : null}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <Pagination
              color="text-primary"
              count={count}
              size="large"
              page={page}
              variant="text"
              shape="round"
              onChange={handleChange}
            />
          </>
        )}

        <Modal show={loginModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              SignUp / Reset Staff | {selectedStaff?.full_name} - EmpCode:{" "}
              {selectedStaff?.emp_code}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group row">
              <div className="col-md-6">
                <label>
                  <b>Enter Email</b>
                </label>
                <input
                  disabled
                  defaultValue={loginEmail}
                  placeholder="Email"
                  type="text"
                  className="form-control"
                />
              </div>
              <div className="col-md-6">
                <label>
                  <b>Enter Password </b>
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  onChange={(e) => {
                    setLoginPassword(e.target.value);
                    if (e.target.value == "") {
                      setErrorCreate("Please Enter 8 digit Password");
                      setIsAllFields(true);
                    } else {
                      setIsAllFields(false);
                    }
                  }}
                  value={loginPassword}
                  placeholder="Password"
                  type="password"
                  className="form-control"
                />
              </div>
            </div>

            <div className="form-group row">
              <div className="col-lg-6">
                <label className="form-label">
                  <b>Select Classes</b> <span style={{ color: "red" }}> *</span>
                </label>
                <MySelect
                  isMulti
                  value={selectedClasses}
                  onChange={(newVal) => handleClassChange(newVal)}
                  options={classesList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  name="selectedClasses"
                  components={{
                    Option,
                    MultiValue,
                    animatedComponents,
                  }}
                  allowSelectAll={true}
                />
              </div>
              <div className="col-lg-6">
                <label>
                  <b>Select Sections</b>{" "}
                  <span style={{ color: "red" }}> *</span>
                </label>
                <MySelect
                  isMulti
                  value={selectedSections}
                  onChange={(newVal) => handleSectionChange(newVal)}
                  options={sectionsList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  name="selectedSetions"
                  components={{
                    Option,
                    MultiValue,
                    animatedComponents,
                  }}
                  allowSelectAll={true}
                />
              </div>
            </div>
            {isAllFields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setIsAllFields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>{errorCreate}</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {loginLoading ? (
              <b>
                <span className="spinner-border"></span>
              </b>
            ) : (
              <>
                <button
                  onClick={loginHandler}
                  className="btn btn-success button_blue "
                >
                  {selectedStaff.user_id == null ? "Login" : "Reset"}
                </button>
                <button
                  className="btn btn-danger btn_width"
                  onClick={() => {
                    setIsAllFields(false);
                    setLoginPassword("");
                    setSelectedClasses([]);
                    setSelectedSections([]);
                    setClassesList([]);
                    setSectionsList([]);
                    setClassSectionArray([]);
                    setLoginModal(false);
                  }}
                >
                  Cancel
                </button>
              </>
            )}
          </Modal.Footer>
        </Modal>

        <Modal show={editModal} size="xl">
          <Modal.Header className="modal_header_style text-center" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Update Staff details
              <h6>
                {currentObject.full_name} | EmpCode: {currentObject.emp_code}
              </h6>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <EditAppointedStaff
              staffDetails={currentObject}
              show={() => seteditModal()}
              reload={() => {
                if (campusID) {
                  handleShowstaff();
                }
              }}
              campusID={campusID}
            />
          </Modal.Body>
        </Modal>

        <Modal show={defineSalaryModal} size="lg">
          <Modal.Header className="modal_header_style text-center" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Define And Update Salary
              <h6>
                {currentObject.full_name} | EmpCode: {currentObject.emp_code}
              </h6>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <DefineSallary
              staffDetails={currentObject}
              show={() => setdefineSalaryModal()}
              reload={() => getAllStaff()}
            />
          </Modal.Body>
        </Modal>

        <Modal size="lg" show={generateModal}>
          <Modal.Header className="modal_header_style text-center" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Generate Sallary
              <h6>
                {currentObject.full_name} | EmpCode: {currentObject.emp_code}
              </h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <GenerateSallary
              reload={() => getAllStaff()}
              show={() => setgenerateModal()}
              empDetails={currentObject}
            />
          </Modal.Body>
        </Modal>

        {/* View Modal  */}
        <Modal onHide={() => setviewModal(false)} show={viewModal} size="xl">
          <Modal.Header className="modal_header_style text-center" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              View Details
              <h6>
                {currentObject.full_name} | EmpCode: {currentObject.emp_code}
              </h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ViewStaffDetails
              EmpDetails={currentObject}
              studentDetails={studentDetails}
            />
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => setviewModal(false)}
              className="btn btn-danger btn_width"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
      </Paper>
    </div>
  );
};

export default AppointedStaff;
